import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Loader2, CheckCircle2 } from 'lucide-react';
import { et, EMBED_LANG } from '../i18n/embedLang';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const GOLD = '#EFC24E';

// Mini-Variante: nur E-Mail + Senden, transparenter Hintergrund.
// Die einbettende Website gestaltet das Design drumherum.
export default function PublicInterestMiniPage() {
  const { source } = useParams();
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await axios.post(`${API}/public/interest-leads`, {
        email,
        phone: phone.trim() || null,
        source: source || 'rapperswil',
        consent: true,
        lang: EMBED_LANG,
      });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || et('Fehler — bitte erneut versuchen.'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-2" style={{ background: 'transparent' }}>
      <div className="w-full max-w-md" data-testid="interest-mini-card">
        {done ? (
          <div className="flex items-center justify-center gap-2 py-3" data-testid="interest-mini-success">
            <CheckCircle2 className="h-5 w-5" style={{ color: GOLD }} />
            <span className="text-sm font-semibold text-white" style={{ textShadow: '0 1px 3px rgba(0,0,0,0.8)' }}>
              {et('Danke! Du bist auf der Liste. 🎉')}
            </span>
          </div>
        ) : (
          <form onSubmit={submit}>
            <div className="flex gap-2">
              <input
                type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="deine@email.ch"
                data-testid="interest-mini-email-input"
                className="flex-1 rounded-lg bg-neutral-900/90 border border-neutral-700 text-white placeholder-neutral-500 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#EFC24E]"
              />
              <button
                type="submit" disabled={busy}
                data-testid="interest-mini-submit-btn"
                className="shrink-0 disabled:opacity-60 text-black font-bold uppercase tracking-wide rounded-lg px-5 text-sm transition-transform hover:scale-[1.03] flex items-center gap-1.5"
                style={{ backgroundColor: GOLD }}
              >
                {busy && <Loader2 className="h-4 w-4 animate-spin" />}
                {et('Senden')}
              </button>
            </div>
            {error && <p className="text-xs text-red-400 mt-1.5" data-testid="interest-mini-error">{error}</p>}
            <input
              type="tel" value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder={et('Handynummer (optional, für WhatsApp-Updates)')}
              data-testid="interest-mini-phone-input"
              className="w-full mt-2 rounded-lg bg-neutral-900/90 border border-neutral-700 text-white placeholder-neutral-500 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#EFC24E]"
            />
            <p className="text-[10px] text-neutral-400 mt-1.5 leading-snug" style={{ textShadow: '0 1px 2px rgba(0,0,0,0.6)' }}>
              {et('Mit dem Absenden stimmst du zu, dass wir deine E-Mail ausschliesslich für Infos zum Studio Rapperswil verwenden.')}
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
